import { I18nModel } from '@bingads-webui/copilot-i18n';

export const getTimePeriod = (date: Date, i18n: I18nModel): string => {
  const currentDate: Date = new Date();
  const diffInDays = Math.floor((currentDate.getTime() - date.getTime()) / (1000 * 60 * 60 * 24));

  if (diffInDays === 0) {
    return i18n.getString(_TL_('Today'));
  }

  if (diffInDays <= 7) {
    return i18n.getString(_TL_('Previous 7 days'));
  }

  if (diffInDays <= 30) {
    return i18n.getString(_TL_('Previous 30 days'));
  }

  const locale = i18n.getLocale();

  // show month if the date is in the current year
  if (date.getFullYear() === currentDate.getFullYear()) {
    return new Intl.DateTimeFormat(locale, { month: 'long' }).format(date);
  }

  return date.getFullYear().toString();
};

